import { hotComics } from '@/mocks/comics';
import ComicCard from './ComicCard';

export default function HotSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              人气热门
            </h2>
            <p className="text-sm text-foreground-600">大家都在看的火爆漫画</p>
          </div>
          <Link
            to="/category/aiqing"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotComics.slice(0, 8).map((comic, idx) => (
            <div
              key={comic.id}
              className="animate-slide-up"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-8">
          <Link
            to="/category/aiqing"
            className="px-6 py-2.5 border-2 border-primary-500 text-primary-500 font-medium rounded-full hover:bg-primary-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap"
          >
            查看更多
          </Link>
        </div>
      </div>
    </section>
  );
}